exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.side-img {\n    max-height:160px;\n}\n\n", ""]);

// exports
